import Task, { TaskStatus, TaskStatuses } from '../Task';
import { State, Action, Actions, createState } from './store';

const initialState: State = {
  isLoading: false,
  error: '',
  tasks: [],
};

const setTaskInProgress = (state: State) => (task: Task, inProgress: boolean): State => {
  const taskIndex = state.tasks.findIndex((t) => t.id === task.id);
  let tasks = [...state.tasks];
  if (taskIndex !== -1) {
    tasks[taskIndex].setIsActionInProgress(inProgress);
  }
  return { ...state, tasks: [...tasks] };
};

const updateTaskStatus = (state: State) => (task: Task, newStatus: TaskStatus): State => {
  const taskIndex = state.tasks.findIndex((t) => t.id === task.id);
  if (taskIndex !== -1) {
    state.tasks[taskIndex].setStatus(newStatus);
  }
  return { ...state };
};

const reducerFunc = (state: State = initialState, action: Action) => {
  const map = new Map([
    [Actions.RESET, createState],

    /*
     * SETTING TASKS
     */
    [
      Actions.SET_TASKS_PENDING,
      () => ({
        ...state,
        isLoading: true,
      }),
    ],
    [
      Actions.SET_TASKS_FINISH,
      () => ({
        ...state,
        isLoading: false,
        tasks: action.payload as Task[],
      }),
    ],
    [
      Actions.SET_TASKS_ERROR,
      () => ({
        ...state,
        isLoading: false,
        tasks: [],
        error: action.payload as string,
      }),
    ],

    /*
     * SINGLE TASK ACTION
     */
    [Actions.SET_TASK_ACTION_IN_PROGRESS, () => setTaskInProgress(state)(action.payload as Task, true)],
    [Actions.SET_TASK_ACTION_FINISH, () => setTaskInProgress(state)(action.payload as Task, false)],
    [Actions.SET_TASK_STATUS_COMPLETED, () => updateTaskStatus(state)(action.payload as Task, TaskStatuses.COMPLETED)],
    [
      Actions.SET_TASK_STATUS_NOT_APPLICABLE,
      () => updateTaskStatus(state)(action.payload as Task, TaskStatuses.NOT_APPLICABLE),
    ],
    [Actions.SET_TASK_STATUS_TODO, () => updateTaskStatus(state)(action.payload as Task, TaskStatuses.TO_DO)],
  ]);

  const actionCallback = map.get(action.type);

  return actionCallback ? actionCallback() : state;
};

export default reducerFunc;
